
<div class="search_result">
  <div class="result"
    *ngFor="let addressBook of addressBooks"
    (click)="onView(addressBook)"
    style="cursor: pointer;"
  >
    <h2 class="name"><i class="ti-user"></i> {{ addressBook?.Name }}</h2>
    <div class="other-info">
      <p class="phone"><i class="ti-mobile"></i>{{ addressBook?.PhoneNo }}</p>
      <p class="email"><i class="ti-email"></i>{{ addressBook?.Email }}</p>
      <p class="account"><i class="ti-info-alt"></i>{{addressBook?.AccountName}}</p>
      <p class="number"><i class="ti-info-alt"></i>{{addressBook?.AccountNo}}</p>
    </div>
  </div>


</div>
